import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { WordpressService } from '../../services/http/wordpress/wordpress.service';
import { WpCityCode, WpClientCode, WpPost, WpSectionCode } from '../../services/http/wordpress/wordpress.interface';
import { ImageSectionHeadComponent } from '../../components/image-section-head/image-section-head.component';

@Component({
  selector: 'app-zbe',
  standalone: true,
  imports: [CommonModule, FormsModule, ImageSectionHeadComponent],
  templateUrl: './zbe.component.html',
  styleUrl: './zbe.component.scss'
})
export class ZbeComponent {
  title = "";
  description = "";
  image = "";

  wpData: WpPost | undefined;

  constructor(
    private readonly wordpressService: WordpressService
  ) { }

  ngOnInit(): void {
    this.wordpressService.getPost({ section: WpSectionCode.zbe, client: WpClientCode.genCat, city: WpCityCode.catalunia }).subscribe((response) => {
      this.wpData = response;
      this.image = response!.acf.image_url;
      this.title = response!.title.rendered;
    });
  }
}
